'use client';
import styled, { keyframes } from 'styled-components';

const bouncing = keyframes`
  30%{
    transform: translateY(0px);
  }
  50%{
    transform: translateY(-15px);
  }
`;

export const StyledAnimatedLoader = styled.div`
  width: 100%;
  height: 100%;
  background-color: ${props => props.theme.colors.background.lightest};
  display: ${props => (props.show ? 'flex' : 'none')};
  flex-direction: column;
  align-items: center;
  justify-content: center;
  z-index: 10;
`;

export const Dots = styled.div`
  display: flex;
  flex-direction: row;
  width: ${props => props.width || '30%'};
  justify-content: space-between;
  padding-top: 16px;
`;

export const Dot = styled.span`
  background-color: ${props => props.theme.colors.text.primary};
  height: 12px;
  width: 12px;
  border-radius: 50%;
  animation-name: ${bouncing};
  animation-duration: 1.4s;
  animation-iteration-count: infinite;
  animation-timing-function: linear;
  &:nth-child(2) {
    animation-delay: 0.4s;
  }
  &:nth-child(3) {
    animation-delay: 0.8s;
  }
`;

export const Message = styled.p`
  font-weight: bold;
  font-size: 1.25rem;
  line-height: 1.25;
  padding-top: 20px;
`;
